

































import { Vue, Component } from 'vue-property-decorator';
import { IMenuRecord } from '@/store/login/types';
import { getStorage } from '@/utils/storage';

// 左边栏主导航
@Component
export default class MainNav extends Vue {
  public expandIndex = 0;
  public expanded = false;

  public get menuList(): IMenuRecord[] {
    return JSON.parse(getStorage('userMenu') || '[]');
  }

  // 刷新页面时，保持主菜单展开
  public created() {
    const path = this.$route.fullPath;

    // 查找当前路由所在主菜单的索引值
    const index = this.menuList.findIndex((item) => {
      if (item.children) {
        return item.children.findIndex((subItem) => path.includes(subItem.link as string)) !== -1;
      } else {
        return item.link === path;
      }
    });

    this.expandIndex = index;
    this.expanded = index !== -1;
  }

  public activeCls(index: number) {
    return this.expandIndex === index ? 'main-menu-active' : '';
  }

  // this.expandIndex === index 表示点击的是同一个菜单，那么只需要切换菜单的状态即可
  // 如果点击的不是同一个菜单，则需要展开当前点击的菜单，即 expand 总是为 true
  public onMenuClick(item: IMenuRecord, index: number) {
    this.expanded = this.expandIndex === index ? !this.expanded : true;
    this.expandIndex = index;
  }
}
